import React from "react";
import { AllImages } from "../../Assets/Images/AllImages";
import user from "../../Common/JsonFiles/simran.json";
import "./Skills.scss";


const Skills = (props) => {
  return (
    <div className={`skills-main-container `}>
      <div className={`${props?.theme}`}>
        <div class="row a-i-f-s j-c-c">
          <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 info-div">
            <div class="accordion" id="frontEndAcc">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    id="frontEndAccButton"
                    data-bs-toggle="collapse"
                    data-bs-target="#frontend"
                    aria-expanded="false"
                    aria-controls="frontend"
                  >
                    <div className="d-flex a-i-c">
                      <img
                        className="skills-img"
                        src={AllImages.ArrowCodeIcon}
                        alt=""
                      />
                      <div>
                        <h3>Frontend</h3>
                        <h6>{user.frontendExp} years</h6>
                      </div>
                    </div>
                  </button>
                </h2>
                <div
                  id="frontend"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#frontEndAcc"
                >
                  <div class="accordion-body">
                    {user?.skills
                      ?.filter((item) => item?.type === "Frontend")
                      ?.map((frontSkill,id) => (
                        <div  key={id.toString()}>
                          <div className="d-flex a-i-c">
                            <p>{frontSkill?.name}</p>
                            <p className="m-l-a">{frontSkill?.percent}%</p>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar"
                              style={{ width: frontSkill?.percent + "%" }}
                            ></div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 img-div">
            <div class="accordion" id="backEndAcc">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button"
                    type="button"
                    id="backEndAccButton"
                    data-bs-toggle="collapse"
                    data-bs-target="#backend"
                    aria-expanded="true"
                    aria-controls="backend"
                  >
                    <div className="d-flex a-i-c">
                      <img
                        className="skills-img"
                        src={AllImages.ArrowCodeIcon}
                        alt=""
                      />
                      <div>
                        <h3>Backend</h3>
                        <h6>{user.backendExp} year</h6>
                      </div>
                    </div>
                  </button>
                </h2>
                <div
                  id="backend"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#backEndAcc"
                >
                  <div class="accordion-body">
                    {user?.skills
                      ?.filter((item) => item?.type === "Backend")
                      ?.map((backSkill,id) => (
                        <div  key={id.toString()}>
                          <div className="d-flex a-i-c">
                            <p>{backSkill?.name}</p>
                            <p className="m-l-a">{backSkill?.percent}%</p>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar"
                              style={{ width: backSkill?.percent + "%" }}
                            ></div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
